
import { Component, Mixins } from "vue-property-decorator";
import {
  PatientProfileInformation,
} from "../../../../domain/patient";
import { HisInformation } from "../../../../domain/his";
import { EditingDocument } from "..";

@Component({
})
export default class ExtraInformationUpdatableMixin extends Mixins() {
  editingSource: EditingDocument;
  writePropertyWhenValid: (writer: (source: EditingDocument) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: EditingDocument) => T, defaultValue: T) => T;

  get hisInformation(): HisInformation {
    return this.readPropertyOrDefault(s => s.hisInformation, null);
  }

  // 現状では未使用
  sethisInformation(info: HisInformation, shouldUpdateEmptyObjectOnly: boolean): void {
    this.writePropertyWhenValid(s => s.setHisInformation(info, shouldUpdateEmptyObjectOnly));
  }

  // いったんはPatientProfileUpdatableMixinで実装したが、DocumentEditableMixinにMixinを増やしたら実行時にエラーになってしまう
  get patientProfile(): PatientProfileInformation {
    return this.readPropertyOrDefault(s => s.patientProfile, null);
  }

  // いったんはPatientProfileUpdatableMixinで実装したが、DocumentEditableMixinにMixinを増やしたら実行時にエラーになってしまう
  set patientProfile(source: PatientProfileInformation) {
    // V1の動作を確認してみた限りでは、文書への反映はしない模様
    this.writePropertyWhenValid(s => s.patientProfile = source);
  }
}
